// extracted by mini-css-extract-plugin
export default {"container":"Carousel_container__MqT9L","imageContainer":"Carousel_imageContainer__0JX0f"};